export const en = {
  header: {
    title: 'Propertly.io Voice Agent',
    subtitle: 'Experience AI-Powered Real Estate Calls',
  },
  hero: {
    badge: 'Try it now',
    title: 'We\'ll call you in 10 seconds',
    subtitle: 'Don\'t imagine how it works. Experience it.',
    description: 'This is a real system call to your phone.',
  },
  howItWorks: {
    title: 'How this demo works:',
    step1: {
      number: '1',
      title: 'Fill out the form below',
      description: 'Enter your brokerage name and your phone number (we will call it in less than 10 seconds)',
    },
    step2: {
      number: '2',
      title: 'We call you immediately',
      description: 'Our system will greet you as your brokerage\'s front desk',
    },
    step3: {
      number: '3',
      title: 'Act like a client',
      description: 'Pretend you\'re a buyer interested in a property, or a seller with a home to list',
    },
  },
  form: {
    businessName: {
      label: 'Your Brokerage Name',
      placeholder: 'Acme Realty',
      hint: 'The system will answer the phone with this name: "Thank you for calling [Your Brokerage]"',
    },
    firstName: {
      label: 'Your First Name',
      placeholder: 'Jane',
    },
    lastName: {
      label: 'Your Last Name',
      placeholder: 'Smith',
      hint: 'The system will address you by name during the call',
    },
    email: {
      label: 'Your Email',
      placeholder: 'jane@company.com',
      hint: 'We\'ll send you the call transcript and summary after the demo',
    },
    intent: {
      label: 'How do you want to test the system?',
      placeholder: 'Choose how you\'ll act on the call',
      hint: 'You\'ll pretend to be a buyer or seller during the demo call',
      options: {
        buy: 'Buy',
        sell: 'Sell',
      },
    },
    selectedListing: {
      label: 'Which property are you "interested in"?',
      placeholder: 'Choose a property to ask about',
      hint: 'When the system asks what you\'re looking for, mention this property',
    },
    location: {
      label: 'Where is your property located?',
      wojewodztwo: {
        label: 'Województwo',
        placeholder: 'Select województwo',
      },
      city: {
        label: 'City',
        placeholder: 'Warsaw',
        optional: '(optional)',
      },
      hint: 'Tell the system about this location when it asks about your property',
    },
    phone: {
      label: 'Your Phone Number',
      placeholder: '+1 415 555 2671',
      hint: 'We\'ll call this number in less than 10 seconds',
    },
    consent: {
      label: 'I agree to receive a live demo call from Propertly.io at the number provided.',
    },
    submit: 'Call Me Now',
    submitting: 'Calling...',
    disclaimer: 'No commitment. No credit card. Just a 2-minute demo call to your phone.',
  },
  success: {
    badge: 'Call in progress',
    title: 'We are calling you now.',
    description: 'Our AI assistant will greet you as your brokerage and continue the conversation.',
    reset: 'Request another call',
  },
  footer: {
    copyright: '© 2024 Propertly.io - Powered by AI Voice Technology',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
  },
};
